module.exports = __webpack_public_path__ + "static/img/logo.e00f10e6.png";